import { services } from '../../../../constants/services';
import { getAll } from '../../../../utils/api';

export const GetComunicationsChannelsWithPaginationService = async () =>{
    const response :any= await getAll<any[]>(`${services['comunication-channels']}`);
    return  response;
};
